import React from "react";
import { Link } from "react-router-dom";
import { useSEO } from "../lib/seo";

const RELATED = [["/terms-and-conditions","Terms & Conditions"],["/privacy-policy","Privacy Policy"],["/shipping-policy","Shipping Policy"],["/cancellation-policy","Cancellation Policy"]];

export default function ReturnRefundPolicy() {
  useSEO({
    title: "Return / Refund Policy — PrintMyTees",
    description: "Read the PrintMyTees Return and Refund Policy covering customised products, damaged or incorrect products, refund requests and customer-selected details.",
  });

  return (
    <main className="container-pmt py-10 sm:py-16 max-w-4xl">
      <div className="overline text-[#E34F26]">PrintMyTees</div>
      <h1 className="mt-3 font-black text-3xl sm:text-4xl md:text-5xl uppercase">Return / Refund Policy</h1>
      <p className="mt-3 text-sm text-stone-600">Last updated: October 2026</p>
      <div className="mt-8 sm:mt-10 space-y-8 sm:space-y-10 text-stone-700 leading-7">
        <section>
          <h2 className="text-xl sm:text-2xl font-bold text-stone-900">1. Customised Products</h2>
          <p className="mt-2">As products may be customised according to customer-selected designs, colours, sizes, names, numbers, text, and printing requirements, customised products may not be eligible for return or refund due to a change of mind.</p>
        </section>

        <section>
          <h2 className="text-xl sm:text-2xl font-bold text-stone-900">2. Damaged or Incorrect Products</h2>
          <p className="mt-2">If you receive a damaged, defective, or incorrectly produced product, contact PrintMyTees as soon as possible, and within 3 days of receiving the product, with your order number and photographs or other relevant details.</p>
        </section>

        <section>
          <h2 className="text-xl sm:text-2xl font-bold text-stone-900">3. Refund Requests</h2>
          <p className="mt-2">Refund requests are reviewed based on the circumstances of the order. If a refund is approved, the amount is processed using the applicable payment method or payment gateway process.</p>
        </section>

        <section>
          <h2 className="text-xl sm:text-2xl font-bold text-stone-900">4. Customer-Selected Details</h2>
          <p className="mt-2">Customers are responsible for checking their selected size, colour, design, names, numbers, text, and other customization details before completing payment. Errors in customer-provided details may not qualify for return or refund.</p>
        </section>

        <section>
          <h2 className="text-xl sm:text-2xl font-bold text-stone-900">5. Order Cancellation</h2>
          <p className="mt-2">Cancellation requests must be made within 1 hour of placing the order. Cancellation may not be possible after production or customisation has started.</p>
        </section>
      </div>
      <div className="mt-10 sm:mt-12 border border-[#E6DFD5] bg-[#F3EDE2] p-5 sm:p-6">
        <div className="overline">Related Policies</div>
        <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 gap-3">
          {RELATED.map(([to,label]) => (
            <Link key={to} to={to} className="btn-outline-pmt text-center focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#D95328] focus-visible:ring-offset-2">{label}</Link>
          ))}
        </div>
      </div>
      <Link to="/" className="inline-block mt-8 sm:mt-10 btn-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#D95328] focus-visible:ring-offset-2">Back to Home</Link>
    </main>
  );
}
